import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getClientByUrlTokenAsync, createGroupAsync } from '../../Services/AdminService';
import { getLearningPathwaysAsync } from '../../Services/CourseService';
import { showToast } from '../../Infrastructure/Notifications/ToastrConfig';
import Header from './../../Shared/Components/Header/Header';
import ClientActions from './Components/ClientActions';
import AssignedPathways from './Components/AssignedPathways';
import ClientCourseAssignments from './Components/ClientCourseAssignments';
import CreateUserModal from './Components/CreateUserModal';
import BulkUploadUsers from './Components/BulkUploadUsers';
import ClientUsersManagement from './Components/ClientUsersManagement';
import Modal from '../../Shared/Components/Modal/Modal';
import ClientConfig from './Components/ClientConfig';
import ClientAutomation from './Components/ClientAutomation';

const Client = () => {
    const [client, setClient] = useState({ groups: [], learningPathways: [] });
    const { urlToken } = useParams();
    const [forceChange, setForceChange] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [groupDescription, setGroupDescription] = useState('');
    const [allLearningPathways, setAllLearningPathways] = useState([]);

    useEffect(() => {
        const getClient = async () => {
            let client = await getClientByUrlTokenAsync(urlToken);
            setClient(client);
        }
        getClient();
    }, [forceChange, urlToken]);

    useEffect(() => {
        const fetchLearningPathways = async () => {
            try {
                const result = await getLearningPathwaysAsync();
                setAllLearningPathways(result.learningPathways || []);
            } catch (error) {
                console.error('Error fetching learning pathways:', error);
                setAllLearningPathways([]);
            }
        };
        fetchLearningPathways();
    }, []);

    const ForceReload = () => {
        setForceChange(!forceChange);
    }

    const handleCreateGroup = async () => {
        if (!groupName.trim()) {
            showToast(false, 'Group name is required');
            return;
        }

        const data = {
            clientId: client.id,
            groupName: groupName,
            groupDescription: groupDescription
        };

        const response = await createGroupAsync(data);
        if (response.success) {
            showToast(true, 'Group created successfully');
            setGroupName('');
            setGroupDescription('');
            ForceReload();
            // Close modal
            document.getElementById('closeCreateGroupModal').click();
        } else {
            showToast(false, response.errors?.[0]?.error || 'Failed to create group');
        }
    }

    // Calculate utilization percentage
    const utilizationPercentage = client.maximumNumberOfLearners > 0
        ? Math.round((client.numberOfLearners / client.maximumNumberOfLearners) * 100)
        : 0;

    return (
        <>
            <Header heading={client.name} icon="apartment" />
            <div className="container-fluid content" style={{
                minHeight: '100vh',
                padding: '40px'
            }}>
                <div style={{ maxWidth: '1400px', margin: '0 auto' }}>

                    {/* Modern Stats Dashboard */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                        gap: '24px',
                        marginBottom: '40px'
                    }}>
                        {/* Current Learners Card */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '32px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(102, 126, 234, 0.1)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            cursor: 'pointer'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-6px)';
                                e.currentTarget.style.boxShadow = '0 16px 48px rgba(102, 126, 234, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.08)';
                            }}>
                            <div style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '16px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '32px',
                                marginBottom: '20px',
                                boxShadow: '0 8px 24px rgba(102, 126, 234, 0.3)'
                            }}>
                                👥
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: '600', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                Current Learners
                            </div>
                            <div style={{ fontSize: '3rem', fontWeight: '800', color: '#1e293b', lineHeight: '1' }}>
                                {client.numberOfLearners || 0}
                            </div>
                        </div>

                        {/* Max Capacity Card */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '32px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(17, 153, 142, 0.1)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            cursor: 'pointer'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-6px)';
                                e.currentTarget.style.boxShadow = '0 16px 48px rgba(17, 153, 142, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.08)';
                            }}>
                            <div style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '16px',
                                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '32px',
                                marginBottom: '20px',
                                boxShadow: '0 8px 24px rgba(17, 153, 142, 0.3)'
                            }}>
                                🎯
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: '600', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                Max Capacity
                            </div>
                            <div style={{ fontSize: '3rem', fontWeight: '800', color: '#1e293b', lineHeight: '1' }}>
                                {client.maximumNumberOfLearners || 0}
                            </div>
                        </div>

                        {/* Groups Card */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '32px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(240, 147, 251, 0.1)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            cursor: 'pointer'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-6px)';
                                e.currentTarget.style.boxShadow = '0 16px 48px rgba(240, 147, 251, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.08)';
                            }}>
                            <div style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '16px',
                                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '32px',
                                marginBottom: '20px',
                                boxShadow: '0 8px 24px rgba(240, 147, 251, 0.3)'
                            }}>
                                👥
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: '600', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                Groups
                            </div>
                            <div style={{ fontSize: '3rem', fontWeight: '800', color: '#1e293b', lineHeight: '1' }}>
                                {client.numberOfGroups || 0}
                            </div>
                        </div>

                        {/* Utilization Card */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '32px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(250, 112, 154, 0.1)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            cursor: 'pointer'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-6px)';
                                e.currentTarget.style.boxShadow = '0 16px 48px rgba(250, 112, 154, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.08)';
                            }}>
                            <div style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '16px',
                                background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '32px',
                                marginBottom: '20px',
                                boxShadow: '0 8px 24px rgba(250, 112, 154, 0.3)'
                            }}>
                                📊
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: '600', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                Utilization
                            </div>
                            <div style={{ fontSize: '3rem', fontWeight: '800', color: '#1e293b', lineHeight: '1' }}>
                                {utilizationPercentage}%
                            </div>
                        </div>
                    </div>

                    {/* User Management Section - Full Width */}
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '32px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                        border: '1px solid rgba(0,0,0,0.05)',
                        marginBottom: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#1e293b',
                            marginBottom: '24px',
                            borderBottom: '3px solid #667eea',
                            paddingBottom: '12px'
                        }}>
                            👤 User Management
                        </h3>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: '16px'
                        }}>
                            <button
                                data-toggle="modal"
                                data-target="#createLearnerModal"
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '12px',
                                    padding: '16px 24px',
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.25)',
                                    transition: 'all 0.3s',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.35)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.25)';
                                }}
                            >
                                <span style={{ fontSize: '1.2rem' }}>👤</span>
                                Create Learner
                            </button>

                            <button
                                data-toggle="modal"
                                data-target="#createClientAdminModal"
                                style={{
                                    background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '12px',
                                    padding: '16px 24px',
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 12px rgba(250, 112, 154, 0.25)',
                                    transition: 'all 0.3s',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(250, 112, 154, 0.35)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(250, 112, 154, 0.25)';
                                }}
                            >
                                <span style={{ fontSize: '1.2rem' }}>👔</span>
                                Create Admin
                            </button>

                            <button
                                data-toggle="modal"
                                data-target="#bulkUploadModal"
                                style={{
                                    background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '12px',
                                    padding: '16px 24px',
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 12px rgba(17, 153, 142, 0.25)',
                                    transition: 'all 0.3s',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(17, 153, 142, 0.35)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(17, 153, 142, 0.25)';
                                }}
                            >
                                <span style={{ fontSize: '1.2rem' }}>📤</span>
                                Bulk Upload
                            </button>

                            <Link
                                to={`/client/${urlToken}/learner-progress`}
                                style={{
                                    background: 'linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '12px',
                                    padding: '16px 24px',
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
                                    transition: 'all 0.3s',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    textDecoration: 'none'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.35)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.25)';
                                }}
                            >
                                <span style={{ fontSize: '1.2rem' }}>📈</span>
                                View Learner Progress
                            </Link>
                        </div>
                    </div>

                    {/* View and Manage All Users Section - Full Width */}
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '32px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                        border: '1px solid rgba(0,0,0,0.05)',
                        marginBottom: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#1e293b',
                            marginBottom: '24px',
                            borderBottom: '3px solid #667eea',
                            paddingBottom: '12px'
                        }}>
                            👥 All Client Users
                        </h3>
                        <ClientUsersManagement clientId={client.id} />
                    </div>

                    {/* Learning Pathways Section - Full Width */}
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '32px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                        border: '1px solid rgba(0,0,0,0.05)',
                        marginBottom: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#1e293b',
                            marginBottom: '24px',
                            borderBottom: '3px solid #667eea',
                            paddingBottom: '12px'
                        }}>
                            🎓 Learning Pathways
                        </h3>
                        <AssignedPathways
                            pathways={client.learningPathways || []}
                            learningPathways={allLearningPathways}
                            clientId={client.id}
                            getClient={ForceReload}
                        />
                    </div>

                    {/* Courses Section - Full Width */}
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '32px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                        border: '1px solid rgba(0,0,0,0.05)',
                        marginBottom: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#1e293b',
                            marginBottom: '24px',
                            borderBottom: '3px solid #667eea',
                            paddingBottom: '12px'
                        }}>
                            📚 Courses
                        </h3>
                        {client.id && (
                            <ClientCourseAssignments
                                clientId={client.id}
                                maximumNumberOfLearners={client.maximumNumberOfLearners}
                            />
                        )}
                    </div>

                    {/* Client Styling Section */}
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '32px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                        border: '1px solid rgba(0,0,0,0.05)',
                        marginBottom: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#1e293b',
                            marginBottom: '24px',
                            borderBottom: '3px solid #667eea',
                            paddingBottom: '12px'
                        }}>
                            🎨 Client Styling
                        </h3>
                        {client.id && <ClientConfig clientId={client.id} clientName={client.name} />}
                    </div>

                    {/* Two Column Layout for Content */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
                        {/* Client Actions - Left Column */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '32px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(0,0,0,0.05)'
                        }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#1e293b',
                                marginBottom: '24px',
                                borderBottom: '3px solid #667eea',
                                paddingBottom: '12px'
                            }}>
                                ⚙️ Client Actions
                            </h3>
                            <ClientActions client={client} getClient={ForceReload} />
                        </div>

                        {/* Groups - Right Column */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '32px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(0,0,0,0.05)'
                        }}>
                            <div style={{ marginBottom: '24px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                    <h3 style={{
                                        fontSize: '1.5rem',
                                        fontWeight: '700',
                                        color: '#1e293b',
                                        margin: 0
                                    }}>
                                        👥 Client Groups
                                    </h3>
                                    <button
                                        data-toggle="modal"
                                        data-target="#createGroupModal"
                                        style={{
                                            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '10px 20px',
                                            fontSize: '0.9rem',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            boxShadow: '0 4px 12px rgba(17, 153, 142, 0.25)',
                                            transition: 'all 0.3s'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(17, 153, 142, 0.35)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(17, 153, 142, 0.25)';
                                        }}
                                    >
                                        + Create Group
                                    </button>
                                </div>
                                <div style={{ borderBottom: '3px solid #11998e', width: '100%' }}></div>
                            </div>
                            <div>
                                {client.groups && client.groups.length > 0 ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                        {client.groups.map((group) => (
                                            <Link
                                                key={group.id}
                                                to={`/client/${urlToken}/group/${group.id}`}
                                                style={{
                                                    textDecoration: 'none',
                                                    color: 'inherit'
                                                }}
                                            >
                                                <div style={{
                                                    background: 'linear-gradient(135deg, #f6f8fb 0%, #ffffff 100%)',
                                                    borderRadius: '12px',
                                                    padding: '20px',
                                                    border: '2px solid #e5e7eb',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer'
                                                }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = '#11998e';
                                                        e.currentTarget.style.transform = 'translateX(4px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = '#e5e7eb';
                                                        e.currentTarget.style.transform = 'translateX(0)';
                                                    }}>
                                                    <div style={{
                                                        fontSize: '1.1rem',
                                                        fontWeight: '700',
                                                        color: '#1e293b',
                                                        marginBottom: '8px'
                                                    }}>
                                                        {group.name}
                                                    </div>
                                                    <div style={{
                                                        fontSize: '0.9rem',
                                                        color: '#64748b'
                                                    }}>
                                                        {group.description}
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                ) : (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '40px',
                                        color: '#64748b',
                                        fontSize: '0.95rem'
                                    }}>
                                        No groups found for this client
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {client.id && (
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '32px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(0,0,0,0.05)',
                            marginTop: '24px'
                        }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#1e293b',
                                marginBottom: '24px',
                                borderBottom: '3px solid #0ea5e9',
                                paddingBottom: '12px'
                            }}>
                                ⏰ Automated Reminders
                            </h3>
                            <ClientAutomation clientId={client.id} clientName={client.name} />
                        </div>
                    )}
                </div>
            </div>

            {/* User Modals */}
            <CreateUserModal
                clientId={client.id}
                userType="Learner"
                groups={client.groups || []}
                onSuccess={ForceReload}
            />
            <CreateUserModal
                clientId={client.id}
                userType="ClientAdmin"
                groups={client.groups || []}
                onSuccess={ForceReload}
            />
            <BulkUploadUsers
                clientId={client.id}
                groups={client.groups || []}
                onSuccess={ForceReload}
            />

            {/* Create Group Modal */}
            <Modal
                modalId="createGroupModal"
                title="Create New Group"
                bodyText={
                    <div style={{ padding: '20px 0' }}>
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{
                                fontWeight: '600',
                                marginBottom: '10px',
                                display: 'block',
                                color: '#1e293b',
                                fontSize: '0.95rem'
                            }}>
                                Group Name <span style={{ color: '#ef4444' }}>*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter group name"
                                value={groupName}
                                onChange={(e) => setGroupName(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '48px',
                                    fontSize: '1rem',
                                    borderRadius: '10px',
                                    border: '2px solid #e2e8f0',
                                    padding: '0 16px',
                                    outline: 'none',
                                    transition: 'all 0.3s ease',
                                    fontFamily: 'inherit'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#11998e';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(17, 153, 142, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#e2e8f0';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                        </div>
                        <div>
                            <label style={{
                                fontWeight: '600',
                                marginBottom: '10px',
                                display: 'block',
                                color: '#1e293b',
                                fontSize: '0.95rem'
                            }}>
                                Group Description
                            </label>
                            <textarea
                                placeholder="Enter group description (optional)"
                                value={groupDescription}
                                onChange={(e) => setGroupDescription(e.target.value)}
                                rows="4"
                                style={{
                                    width: '100%',
                                    fontSize: '1rem',
                                    borderRadius: '10px',
                                    border: '2px solid #e2e8f0',
                                    padding: '12px 16px',
                                    outline: 'none',
                                    transition: 'all 0.3s ease',
                                    resize: 'vertical',
                                    fontFamily: 'inherit',
                                    lineHeight: '1.5'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#11998e';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(17, 153, 142, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#e2e8f0';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                        </div>
                    </div>
                }
                buttonText="Create Group"
                buttonFunc={handleCreateGroup}
            />
        </>
    );
};

export default Client;